export default {
  root: {
    margin: 0,
    padding: 16,
    height: "70px",
    display: "flex",
  },
  center: {
    // margin: 'auto',
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    right: 16,
    marginTop: "5px",
    color: "#F54040",
    background: "#F4F4F4",
  },
  closeButtonResp: {
    color: "#F54040",
    background: "#F4F4F4",
  },
  button: {
    "&:hover": {
      background: "none",
    },
  },
  select: {
    "&:focus": {
      background: "none",
    },
  },
  deleteImageDiv: {
    width: "25px",
    height: "25px",
    background: "#000",
    opacity: 0.8,
    borderRadius: "50%",
    marginLeft: "42px",
    marginTop: "-70px",
  },
  deleteImage: {
    marginLeft: "6px",
    marginTop: "3px",
    width: "13px",
  },
  loader: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
};
